const defaultState = () => ({
	exports: [],
	export: {},
});

const state = {
	exports: defaultState().exports,
	export: defaultState().export,
};

const getters = {
	exportsList: (state) => {
		return state.exports;
	},
	exportItem: (state) => {
		if ("undefined" != typeof state.export.payload)
			state.export.payload =
				"string" == typeof state.export.payload
					? JSON.parse(state.export.payload)
					: state.export.payload;

		return state.export;
	},
};

const actions = {};

const mutations = {
	GET_EXPORTS: (state, items) => {
		state.exports = items;
	},
	GET_EXPORT: (state, item) => {
		state.export = item;
	},
	SAVE_EXPORT: (state, item) => {
		state.exports.push(item);
	},
	UPDATE_EXPORT: (state, item) => {
		const idx = state.exports.findIndex((eitem) => eitem.id === item.id);

		if (0 <= idx) state.exports.splice(idx, 1, item);

		if (item.id === state.export.id) state.export = item;
	},
	// Patch a few fields on ONE row in place (e.g. after cancel/pause/resume),
	// so only that row re-renders. Avoids replacing the whole list, which made
	// b-table re-diff every row and briefly flash the wrong status on the
	// neighbouring row.
	PATCH_EXPORT: (state, { id, fields }) => {
		const idx = state.exports.findIndex((eitem) => eitem.id === id);

		if (0 <= idx)
			state.exports.splice(idx, 1, { ...state.exports[idx], ...fields });
	},
	DELETE_EXPORT: (state, id) => {
		const idx = state.exports.findIndex((item) => item.id == id);

		if (0 <= idx) state.exports.splice(idx, 1);

		if (id === state.export.id) state.export = {};
	},
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
